import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=543a025d&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=543a025d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543a025d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543a025d')) {
      api.createRecord('543a025d', component.options)
    } else {
      api.reload('543a025d', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=543a025d&scoped=true&", function () {
      api.rerender('543a025d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/message/detail.vue"
export default component.exports